export default __webpack_public_path__ + "static/media/009-soldier.84bcedab.png";